import { lazy } from 'react';

export const Admin = lazy(function factory() {
  return import(/* webpackChunkName: "admin" */'./Admin');
});

export const Root = lazy(function factory() {
  return import(/* webpackChunkName: "app" */'./Root');
});
